module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eB9rs"))).then(() => module.bundle.root('ljYL6'));